export default __webpack_public_path__ + "static/media/gameRoom.cc40f655.png";